<script>
import { mapGetters } from 'vuex'
import TeamResource from '@/resources/team'

export default {
    name: 'AccountLapTimes',
    computed: {
        ...mapGetters(['userId']),
    },
    data() {
        return {
            hasTeams: false,
        }
    },
    async mounted() {
        const teams = await TeamResource.filterAll({ members: this.userId })
        this.hasTeams = teams.length > 0
    },
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Rundenzeiten</h4>
            <p class="text-muted mb-0">Überprüfe deine Rennleistung und vergleiche dich mit anderen.</p>
        </div>
        <b-row>
            <b-col md="6" class="mb-3">
                <b-card class="h-100">
                    <div class="d-flex align-items-start">
                        <b-icon icon="stopwatch-fill" scale="2" class="text-primary mr-3 flex-shrink-0" style="margin-top: 2px" />
                        <div>
                            <h6 class="mb-1">Meine Runden</h6>
                            <p class="text-muted small mb-3">Sieh dir deine persönlichen Rundenzeiten und deinen Sitzungsverlauf an.</p>
                            <b-button variant="outline-primary" size="sm" :to="{ name: 'laps' }">Zu „Meine Runden“</b-button>
                        </div>
                    </div>
                </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
                <b-card class="h-100">
                    <div class="d-flex align-items-start">
                        <b-icon icon="bar-chart-fill" scale="2" class="text-primary mr-3 flex-shrink-0" style="margin-top: 2px" />
                        <div>
                            <h6 class="mb-1">Ranglisten</h6>
                            <p class="text-muted small mb-3">Sieh dir an, wie du im Vergleich zu anderen Fahrern auf jeder Strecke abschneidest.</p>
                            <b-button variant="outline-primary" size="sm" :to="{ name: 'leaderboards' }">Zu den Ranglisten</b-button>
                        </div>
                    </div>
                </b-card>
            </b-col>
            <b-col md="6" class="mb-3" v-if="hasTeams">
                <b-card class="h-100">
                    <div class="d-flex align-items-start">
                        <b-icon icon="people-fill" scale="2" class="text-primary mr-3 flex-shrink-0" style="margin-top: 2px" />
                        <div>
                            <h6 class="mb-1">Teams</h6>
                            <p class="text-muted small mb-3">Verwalte die Teams, mit denen du in Punkteserien fährst.</p>
                            <b-button variant="outline-primary" size="sm" :to="{ name: 'accountTeams' }">Zu den Teams</b-button>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
